
/**
 * 수료증 유형
 */
export type CertificateInfoCertificateType = typeof CertificateInfoCertificateType[keyof typeof CertificateInfoCertificateType];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const CertificateInfoCertificateType = {
  COMPLETION: 'COMPLETION',
  PARTICIPATION: 'PARTICIPATION',
  ACHIEVEMENT: 'ACHIEVEMENT',
} as const;
